import { CommonModule } from '@angular/common';
import { Injectable, NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { LeaderBoardModule } from 'src/app/pages/leader-board/leader-board.module';
import { CustomizeFormModule } from 'src/app/shared/components/customize-form/customize-form.module';
import { EmptyModule } from 'src/app/shared/components/empty/empty.module';
import { LazyImageComponent } from 'src/app/shared/components/lazy-image/lazy-image.component';
import { PaginatorModule } from 'src/app/shared/components/paginator/paginator.module';
import { ScrollSelectItemModule } from 'src/app/shared/components/scroll-select-item/scroll-select-item.module';
import { ScrollbarModule } from 'src/app/shared/components/scrollbar/scrollbar.module';
import { IntersectionObserverModule } from 'src/app/shared/directive/intersection-observer/intersection-observer.module';
import { LoadingModule } from 'src/app/shared/directive/loading/loading.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { RightCombinePopupComponent } from './right-combine-popup.component';

@Injectable()
class HammerConfig extends HammerGestureConfig {
  overrides = {
    pan: {},
    swipe: {
      direction: Hammer.DIRECTION_ALL,
    },
    press: { time: 1000 },
  };
}
@NgModule({
  imports: [
    CommonModule,
    ScrollbarModule,
    RouterModule,
    LoadingModule,
    EmptyModule,
    CustomizeFormModule,
    PipesModule,
    IntersectionObserverModule,
    PaginatorModule,
    LeaderBoardModule,
    MatTabsModule,
    MatCheckboxModule,
    ScrollSelectItemModule,
    LazyImageComponent,
  ],
  declarations: [RightCombinePopupComponent],
  exports: [RightCombinePopupComponent],
  providers: [
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfig,
    },
  ],
})
export class RightCombinePopupModule {}
